/**
 * English translations - Source of truth
 * All other language files should match this structure
 */
import { common } from './en/common';
import { dashboard } from './en/dashboard';
import { vision2040 } from './en/vision2040';
import { mentalHealth } from './en/mentalHealth';
import { members } from './en/members';
import { programs } from './en/programs';
import { technology } from './en/technology';
import { regional } from './en/regional';
import { impact } from './en/impact';
import { workforce } from './en/workforce';
import { entrepreneurship } from './en/entrepreneurship';
import { contributing } from './en/contributing';
import { faq } from './en/faq';
import { methodology } from './en/methodology';
import { developmentCouncils } from './en/developmentCouncils';
import { privacy } from './en/privacy';
import { terms } from './en/terms';
import { countryProfile } from './en/countryProfile';

// NOTE: both Programs & Events and Technology modules used the same root key "programs".
// We deep-merge here to prevent one module from overwriting the other.
const { programs: programsLabels, ...programsRest } = programs;
const { programs: technologyProgramLabels, ...technologyRest } = technology;

export const en = {
  ...common,
  ...dashboard,
  ...mentalHealth,
  ...regional,
  ...members,
  ...programsRest,
  ...impact,
  ...technologyRest,
  ...vision2040,
  ...workforce,
  ...entrepreneurship,
  ...contributing,
  ...methodology,
  ...developmentCouncils,
  ...countryProfile,
  privacy,
  terms,
  faq,
  programs: {
    ...programsLabels,
    ...technologyProgramLabels,
  },
} as const;

export type EnTranslations = typeof en;

